import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetUserError, SetUserLoading } from '@tsin-core/actions/user.action';
import { LearnerUserModel } from '@tsin-core/models/auth.model';
import { LoadingUserState, UserStateModel } from '@tsin-core/models/user.model';
import { UserService } from '@tsin-core/services/http/user.service';
import { catchError, Observable, of, tap } from 'rxjs';

@State<UserStateModel>({
    name: 'userState',
    defaults: {
        loading: LoadingUserState.loadingList,
        users: [],
        guests: [],
        error: null,
    },
})
@Injectable()
export class UserState {
    userService: UserService = inject(UserService);
    //
    @Selector()
    static getGuests(state: UserStateModel) {
        return state.guests;
    }

    @Selector()
    static getUsers(state: UserStateModel) {
        return state.users;
    } 
    
    @Selector()
    static getLoading(state: UserStateModel) {
        return state.loading;
    }

    @Selector()
    static getError(state: UserStateModel) {
        return state.error;
    }

    @Action(SetUserLoading)
    setLoading(ctx: StateContext<UserStateModel>, action: SetUserLoading) {
        ctx.patchState({ loading: action.loading });
    }

    @Action(SetUserError)
    setError(ctx: StateContext<UserStateModel>, action: SetUserError) {
        ctx.patchState({ error: action.error });
    }
}
